import React from 'react';
import { ShieldCheck, Zap, Gauge } from 'lucide-react';

const items = [
  {
    id: 'why',
    label: 'Why Choose JILONG',
    sub: 'Mengapa Memilih JILONG',
    icon: ShieldCheck,
    link: '#about',
  },
  {
    id: 'splicing',
    label: 'Fusion Splicing',
    sub: 'Penyambung Fusi',
    icon: Zap,
    link: '/produk/fusion-splicing',
  },
  {
    id: 'instruments',
    label: 'Instruments',
    sub: 'Instrumen Pengukur',
    icon: Gauge,
    link: '/produk/instruments',
  },
];

const handleClick = (e, link) => {
  if (link.startsWith('#')) {
    e.preventDefault();
    const el = document.querySelector(link);
    if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }
  // route links: let browser navigate normally
};

const CategoryIconStrip = () => {
  return (
    <section
      className="relative -mt-8 z-20 px-4 sm:px-6 lg:px-8"
      data-testid="category-strip"
    >
      <div className="max-w-7xl mx-auto bg-white rounded-2xl shadow-2xl border border-gray-100 overflow-hidden">
        <div className="grid grid-cols-1 sm:grid-cols-3 divide-x divide-gray-100">
          {items.map((it) => {
            const Icon = it.icon;
            return (
              <a
                key={it.id}
                href={it.link}
                onClick={(e) => handleClick(e, it.link)}
                data-testid={`cat-icon-${it.id}`}
                className="category-icon-cell group flex flex-col items-center justify-center text-center px-4 py-7 transition-colors hover:bg-[#0a3d8f]"
              >
                <div className="category-icon-circle w-14 h-14 rounded-full bg-blue-50 group-hover:bg-white flex items-center justify-center mb-3 transition-colors">
                  <Icon
                    size={26}
                    className="text-[#0a3d8f] group-hover:text-[#0a3d8f] transition-colors"
                  />
                </div>
                <div className="text-[15px] font-bold text-gray-900 group-hover:text-white transition-colors font-[Montserrat]">
                  {it.label}
                </div>
                <div className="text-xs text-gray-500 group-hover:text-blue-100 mt-0.5 transition-colors">
                  {it.sub}
                </div>
              </a>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default CategoryIconStrip;
